// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "scrollBody-2j8Qf";
var _4 = "paper-2VanC";
export { _1 as "__esModule", _2 as "mobile", _3 as "scrollBody", _4 as "paper" }
export default { "__esModule": _1, "mobile": _2, "scrollBody": _3, "paper": _4 }
